import { categories } from '@/mocks/categories';

export default function CategoryCards() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
            All Product Categories
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Every category is meticulously organized in Vigorbuy spreadsheets so you can compare, filter, and find exactly what you need without the guesswork
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat, index) => (
            <a
              key={index}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-44 overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={`${cat.name} Vigorbuy Spreadsheet category`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={`${cat.name} - Vigorbuy Spreadsheet`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1.5">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {cat.description}
                </p>
                <div className="mt-3 flex items-center gap-1 text-primary-500 text-xs font-medium">
                  <span>Explore</span>
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}